import CardGrid from './CardGridFlikity'
export default CardGrid



// WEBPACK FOOTER //
// ./src/components/Card/CardGrid.js